(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bzk-growth-events"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bzkGrowthEventsBound) return;
    window.bzkGrowthEventsBound = true;

    const placements = ['product', 'mobile_sticky', 'intro', 'closing'];

    function analyticsAllowed() {
      try {
        return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch {
        return false;
      }
    }

    function emit(event, channel, element) {
      if (!analyticsAllowed()) return;
      const placement = element?.getAttribute('data-bzk-growth-placement');
      window.dataLayer = window.dataLayer || [];
      const payload = {
        event,
        channel,
        page_path: window.location.pathname,
        placement: placements.includes(placement) ? placement : 'other',
      };
      window.dataLayer.push(payload);

      const ga4Event = event === 'bzk_contact_click' && channel === 'whatsapp'
        ? 'bzk_whatsapp_click'
        : event;
      if (!['bzk_quote_click', 'bzk_whatsapp_click', 'bzk_contact_submitted'].includes(ga4Event)) return;
      if (typeof window.gtag !== 'function') return;

      // Reuse the existing configured Google tag; never create another config.
      window.gtag('event', ga4Event, {
        send_to: 'G-B70N0LLWXD',
        channel: payload.channel,
        page_path: payload.page_path,
        placement: payload.placement,
        page_location: window.location.origin + payload.page_path,
        page_referrer: '',
        page_title: 'Bizak & Co. sourcing enquiry',
      });
    }

    document.addEventListener('click', (event) => {
      const element = event.target?.closest?.('[data-bzk-growth-action], a[href]');
      if (!element) return;

      const action = element.getAttribute('data-bzk-growth-action');
      if (action === 'product_quote' || action === 'article_quote' || action === 'collection_quote') {
        emit('bzk_quote_click', 'contact_form', element);
        return;
      }
      if (action === 'offer_open') {
        emit('bzk_quote_click', 'offer_form', element);
        return;
      }
      if (action === 'whatsapp') {
        emit('bzk_contact_click', 'whatsapp', element);
        return;
      }

      const href = element.getAttribute('href');
      if (!href) return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.protocol === 'tel:') {
          emit('bzk_contact_click', 'phone', element);
        } else if (
          url.protocol === 'whatsapp:' ||
          (['https:', 'http:'].includes(url.protocol) &&
            ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname))
        ) {
          emit('bzk_contact_click', 'whatsapp', element);
        }
      } catch {}
    }, true);

    let serverSuccessReported = false;

    function reportServerSuccess() {
      if (serverSuccessReported || document.readyState === 'loading' || !analyticsAllowed()) return;
      const success = document.querySelector('[data-bzk-quote-success]');
      if (success) {
        serverSuccessReported = true;
        emit('bzk_contact_submitted', 'contact_form', success);
      }
    }

    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) reportServerSuccess();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reportServerSuccess, { once: true });
    } else {
      reportServerSuccess();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    function initializeSourcingContacts(root = document) {
    root.querySelectorAll('[data-bzk-sourcing-contact]').forEach((container) => {
      if (container.dataset.bzkContactReady) return;
      container.dataset.bzkContactReady = 'true';
      const form = container.querySelector('form');
      const source = form.querySelector('[data-bzk-quote-source]');
      const validSourcePath = (value) => {
        if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\?#\s\u0000-\u001f]/.test(value) || /%(?:2f|5c|3f|23|0[0-9a-f]|1[0-9a-f]|7f)/i.test(value)) return '';
        try {
          const url = new URL(value, window.location.origin);
          return url.origin === window.location.origin && !url.search && !url.hash && url.pathname === value ? url.pathname : '';
        } catch {
          return '';
        }
      };
      source.value = validSourcePath(source.value);
      if (form.querySelector('[data-bzk-contact-errors], [data-bzk-quote-success]')) return;
      const params = new URLSearchParams(window.location.search);
      if (params.get('intent') !== 'sourcing') return;
      form.querySelector('[data-bzk-inquiry-type]').value = 'Sourcing inquiry';
      const prefill = (selector, parameter) => {
        const input = form.querySelector(selector);
        if (!input.value) input.value = (params.get(parameter) || '').trim().slice(0, input.maxLength);
      };
      prefill('[data-bzk-quote-subject]', 'subject');
      prefill('[data-bzk-quote-reference]', 'reference');
      if (!source.value) source.value = validSourcePath(params.get('source') || '');
    });
  }
  initializeSourcingContacts();
  document.addEventListener('shopify:section:load', (event) => initializeSourcingContacts(event.target));
  } catch(e) { console.error(e); }
})();

})();
